import { createContext, useContext } from 'react';
import { getFeatures } from './getFeatures';

/**
 * @typedef {import('./getFeatures.js').FeatureConfig} FeatureConfig
 */

/**
 * @typedef {{config: FeatureConfig, locale: string}} FeaturesContext
 */

/**
 * @type {React.Context<FeaturesContext>}
 */
const FeaturesContext = /*#__PURE__*/createContext({
  config: {},
  locale: 'de'
});
export const FeaturesProvider = FeaturesContext.Provider;

/**
 * Custom hook to get locale features
 */
export function useFeatures() {
  const {
    config,
    locale
  } = useContext(FeaturesContext);
  return getFeatures(config, locale);
}